const sessionStorageDeviceIdKey = 'onlinePressDeviceId';

(function () {
    initOnlinePressWebComponent();
})();

function initOnlinePressWebComponent() {
    const deviceIdFromUrl = extractDeviceIdFromUrl(window.location);
    if (deviceIdFromUrl) {
        saveToStorage(sessionStorageDeviceIdKey, deviceIdFromUrl);
    }

    const deviceId = deviceIdFromUrl ?? readFromStorage(sessionStorageDeviceIdKey);
    if (!deviceId) {
        throw new Error('deviceId not found in url query params');
    }

    const wrapper = document.getElementById('onlinePressRoot');
    const onlinePressRootEl = document.createElement('dt-online-press-root');

    wrapper.appendChild(onlinePressRootEl);
}

function getUrlParams(loc) {
    return new URLSearchParams(loc.search);
}

function extractDeviceIdFromUrl(loc) {
    return getUrlParams(loc).get('deviceId');
}

function saveToStorage(key, value) {
    sessionStorage.setItem(key, value);
}

function readFromStorage(key) {
    return sessionStorage.getItem(key);
}
